import SridSelector from '@/components/SridSelector';
import { Button } from '@/components/ui/button';
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { execute } from '@/graphql/execute';
import { createProjectMutation } from '@/queries/project.query';
import { useFormik } from 'formik';
import posthog from 'posthog-js';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const ProjectCreateModal: FunctionComponent<{ onSuccess: () => void; organizationId: string }> = ({
  onSuccess,
  organizationId,
}) => {
  const navigate = useNavigate();
  const formik = useFormik<{ name: string; srid: number }>({
    initialValues: {
      name: '',
      srid: 4326,
    },
    onSubmit: async (values) => {
      if (!organizationId) return;
      const toastId = toast.loading('Creating project...');
      const res = await execute(createProjectMutation, {
        input: { name: values.name, organizationId, srid: values.srid },
      });
      toast.success('Project created', { id: toastId });
      navigate(`/projects/${res.createProject.id}`);
      onSuccess();
      posthog.capture('Project Created');
    },
  });

  return (
    <DialogContent className='sm:max-w-[520px]'>
      <DialogHeader>
        <DialogTitle>Create project</DialogTitle>
        <DialogDescription>Create a new project here.</DialogDescription>
      </DialogHeader>
      <div className='grid gap-4'>
        <div className='grid gap-3'>
          <Label htmlFor='name-1'>Name</Label>
          <Input
            id='name-1'
            name='name'
            value={formik.values.name}
            onChange={formik.handleChange}
            placeholder='Project name'
          />
        </div>
        <div className='grid gap-3'>
          <Label>EPSG (SRID)</Label>
          <SridSelector
            className='w-full'
            value={formik.values.srid.toString()}
            onChange={(value) => formik.setFieldValue('srid', parseInt(value))}
          />
        </div>
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant='outline'>Cancel</Button>
        </DialogClose>
        <DialogClose asChild>
          <Button type='submit' onClick={formik.submitForm} disabled={formik.isSubmitting || !formik.dirty}>
            Save changes
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};

export default ProjectCreateModal;
